import { useMemo, useState, useCallback, useEffect } from "react";
import Toolbar from "../controls/Toolbar";
import { useTranslation } from "react-i18next";
import Monitoring from "../../services/monitoring";
import Utils from "../../utils/utils";
import PubSub from "../../services/PubSub";

const SiteMonitoring = () => {
    const [translate] = useTranslation();
    const [monitors, setMonitors] = useState([]);
    const [loading, setLoading] = useState(false); 

    const getStatuses = useCallback(async () => {
        setLoading(true);
        const response = await Monitoring.getStatuses(Utils.getDomain());

        if (!response.error) {
            setMonitors(response.data);
        }
        else {
            PubSub.publish("show_info", response.data.error);
        }
        setLoading(false);
    }, [setMonitors]);

    useEffect(() => {
        getStatuses();
    }, [getStatuses]);

    const renderMonitorList = useMemo(() => {
        if(monitors.length === 0) {
            return <div className="col-12 opacity-50 d-flex p-3 justify-content-center">
                        {translate("OTM_NO_MONITORS")}
                    </div>
        }
        return monitors.map((item, index) => (
            <li key={index} className="list-group-item bg-light p-0 border-0">
                <div className="p-3 rounded bg-white">
                    <div className="row align-items-center mt-n2">
                        <div className="col-12 col-md-auto">
                            <div className="badge bg-secondary p-2">{Utils.getFormattedDateTime(item.lastPolled)}</div>
                        </div>
                        <div className="col-8 col-md-auto">
                            {item.url}
                        </div>
                        <div className="col-4 col-md d-flex justify-content-end">
                            <div className={`badge ${item.status === 'Available' ? 'bg-success' : 'bg-danger'} p-2`}>{item.status}</div>
                        </div>
                    </div>
                </div>
            </li>
        ));
    }, [monitors, translate]);

    const renderToolbar = useMemo(() => (
        <Toolbar
            buttons={[
                {
                    name: "Refresh",
                    title: translate("OTM_REFRESH"),
                    onClick: getStatuses,
                    disabled: loading
                }
            ]}
            heading={translate("OTM_MONITORING")}
        />
    ), [translate, getStatuses, loading]);

    const renderSiteMonitoring = useMemo(() => (
        <div className="p-0 mt-3 d-flex flex-column overflow-auto">
            <div className="card mb-3">
                <div className="card-header border-bottom">
                    {renderToolbar}
                </div>
                <div className="card-body p-0 mb-3">
                    {renderMonitorList}
                </div>
            </div>
        </div>

    ), [renderMonitorList, renderToolbar]);

    return renderSiteMonitoring;
};

export default SiteMonitoring;